<script setup lang="ts">
import type { PropertyAreaProps } from '.';

import { propertyAreaInputVariants } from '.';

const props = withDefaults(defineProps<PropertyAreaProps>(), {
	variant: 'primary'
});

const min = defineModel<number | null>('min');
const max = defineModel<number | null>('max');
</script>

<template>
	<IntervalInput
		v-model:min="min"
		v-model:max="max"
		title="Área útil"
		unit="area"
		min-label="Área mínima"
		max-label="Área máxima"
		update-on="blur"
		:variant="props.variant"
		:input-classes="propertyAreaInputVariants({ variant: props.variant })"
	/>
</template>
